import React from "react";
import AgreementCheckbox from "../AgreementCheckbox";

const ShareInformationCheckbox = ({ isChecked, onChange }) => (
  <AgreementCheckbox
    isChecked={isChecked}
    onChange={onChange}
    name="isAgreeSharedInformation"
  >
    {"Prihvaćam da se moji kontakt-podaci (e-mail adresa i ime) proslijede oglašivaču kako bi mogao odgovoriti na upit."}
  </AgreementCheckbox>
);

export default ShareInformationCheckbox;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/AgreementSection/ShareInformationCheckbox/index.tsx